export const concatString = string => string.toLowerCase().replace(' ', '_')
